import { Grid, Typography } from '@mui/material';
import CustomAccordion from '../../../common/CustomAccordion';

const Section = ({ section, children, grouped = true }: any) => {
  const typographyTitle = (
    <Typography variant="subtitle1">
      {section.title}
      <Typography variant="caption">
        &nbsp;({section.totalFields} items)
      </Typography>
    </Typography>
  );

  if (!grouped) {
    return (
      <Grid container key={section.key}>
        {section?.fields?.map((field: any) => {
          return <Grid size={12}>{children(field)}</Grid>;
        })}
      </Grid>
    );
  }

  return (
    <CustomAccordion
      key={section.key}
      title={typographyTitle}
      defaultExpanded={false}
      variant="medium"
    >
      {section?.fields?.map(children)}
    </CustomAccordion>
  );
};

export default Section;
